import { ChevronDown } from "lucide-react";
import { getPropertyTypeLabel } from "../../utils/common";

const formatValue = (val) => {
  if (val === null || val === undefined || val === "" || val === "unknown" || val === "false" || val === false || val === "N/A" || val === "null" || val === "undefined") {
    return <span className="!text-red-500 !font-medium">Not mentioned</span>;
  }
  return val;
};

const PropertyCard = ({ property, type, expanded, onToggle }) => {
  const isExpanded = expanded ?? false;

  return (
    <div className="!border !border-gray-200 !rounded-md !p-3 !mb-2 !bg-gray-50">
      {/* Header */}
      <div className="!flex !justify-between !items-center !cursor-pointer" onClick={onToggle}>
        <p className="!text-sm !font-medium !text-gray-700">{formatValue(property.address)}</p>
        <ChevronDown size={18} className={`!text-gray-600 !transition-transform !duration-300 ${isExpanded ? "!rotate-180" : "!rotate-0"}`} />
      </div>

      {/* Collapsible Details */}
      <div className={`!transition-all !duration-300 !ease-in-out !overflow-hidden !border-t !border-slate-400 ${isExpanded ? "!max-h-[400px] !opacity-100 !mt-2" : "!max-h-0 !opacity-0"}`}>
        <ul className="!text-xs !text-gray-600 !list-none !space-y-1 !grid !grid-cols-2 !text-left !mt-2">
          <li className="!col-span-1">
            <span className="!font-semibold">Address:</span> {formatValue(property.address)}
          </li>
          <li className="!col-span-1">
            <span className="!font-semibold">City:</span> {formatValue(property.city)}
          </li>
          <li className="!col-span-1">
            <span className="!font-semibold">State:</span> {formatValue(property.state)}
          </li>
          <li className="!col-span-1">
            <span className="!font-semibold">County:</span> {formatValue(property.county)}
          </li>
          <li className="!col-span-2">
            <span className="!font-semibold">Subdivision:</span> {formatValue(property.subdivision)}
          </li>
          <li className="!col-span-2">
            <span className="!font-semibold">Property Type:</span> {getPropertyTypeLabel(property.property_type)}
          </li>
          <li className="!col-span-1">
            <span className="!font-semibold">Recording Date:</span> {property.recording_date ? new Date(property.recording_date).toLocaleDateString() : formatValue(null)}
          </li>
          <li className="!col-span-1">
            <span className="!font-semibold">Document Date:</span> {property.document_date ? new Date(property.document_date).toLocaleDateString() : formatValue(null)}
          </li>
          <li className="!col-span-1">
            <span className="!font-semibold">Transfer Amount:</span> {property.transfer_amount ? `$${property.transfer_amount}` : formatValue(null)}
          </li>
          <li className="!col-span-2">
            <span className="!font-semibold">Owners:</span> {property.owners?.length > 0 ? property.owners.join(", ") : formatValue(null)}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PropertyCard;
